import React from 'react';
import { openNewWindow, setColumnWidth, setDetailPageUrl } from '../../../../lib/common';
import CouponBenefit from '../../common/CouponBenefit';
import CouponBenefitInfo from '../../common/CouponBenefitInfo';
import InputForm from '../../../../components/form/InputForm';
import CouponPeriod from '../../common/CouponPeriod';
import { formRequiredRules } from '../../../../lib/formRules';
import Anchor from '../../../../components/link/Anchor';
import { setDateFormat } from '../../../../lib/moment';
import {
  COUPON_AVAILABLE_TYPE_TEXT,
  MAXIMUM_NUMBER_OF_COUPON_ISSUED_COUNT,
  MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT,
} from '../../../../constants/service/app/couponConstants';
import { REX_NUMBER } from '../../../../lib/rex';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { COUPON_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { REQUIRED_MSG } from '../../../../constants/service/common/formRulesConstants';

/**
 * react-table v6 Cell 안정화를 위해 모듈 레벨에서 정의
 */
const IssuedCountCell = (row) => {
  const { form, setData } = row.column;
  return (
    <InputForm
      className="issuedCount"
      type="number"
      form={form}
      name={`issuedCount_${row.original.id}`}
      initialValue={MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT}
      min={MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT}
      max={MAXIMUM_NUMBER_OF_COUPON_ISSUED_COUNT}
      rules={[
        formRequiredRules(true, REQUIRED_MSG, false),
        { pattern: REX_NUMBER, message: '숫자만 들어갈 수 있습니다.' },
      ]}
      onChange={(value) => {
        setData({
          path: ['selectedCouponInfoList', row.index, 'issuedCount'],
          value,
        });
      }}
    />
  );
};

/**
 *  쿠폰 리스트 컬럼
 */
const columns = (data) => {
  const { form, setData, list, toggleModal } = data;

  return [
    {
      accessor: 'id',
      Header: '쿠폰 ID',
      fixed: 'left',
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(COUPON_DETAIL_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'name',
      Header: '쿠폰명',
      className: 'align-left',
      resizable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'name'),
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          onClick={() =>
            toggleModal({
              name: 'couponDetailModal',
              value: true,
              data: {
                couponDetail: row.original,
              },
            })
          }
          text={`${row.original.name}`}
        />
      ),
    },
    {
      accessor: 'description',
      Header: '쿠폰 설명',
      className: 'align-left',
      resizable: true,
      fixed: 'left',
      width: 200,
    },
    {
      accessor: 'discountType',
      Header: '쿠폰 혜택',
      fixed: 'left',
      width: 120,
      Cell: (row) => <CouponBenefit type={row.value} amount={row.original.discountAmount} />,
    },
    {
      Header: '발급 갯수',
      fixed: 'left',
      width: 120,
      form,
      setData,
      Cell: IssuedCountCell,
    },
    {
      accessor: 'availableType',
      Header: '쿠폰 유형',
      width: 100,
      Cell: (row) => COUPON_AVAILABLE_TYPE_TEXT[row.value] || '_',
    },
    {
      Header: '쿠폰 혜택 정보',
      resizable: true,
      width: 160,
      Cell: (row) => (
        <CouponBenefitInfo
          type={row.original.discountType}
          amount={row.original.discountAmount}
          minimumPurchasePrice={row.original.minimumPurchasePrice}
          maxDiscountPrice={row.original.maxDiscountPrice}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '생성일자',
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      Header: '사용기간',
      width: 290,
      Cell: (row) => (
        <CouponPeriod
          type={row.original.periodType}
          startDate={row.original.startDate}
          endDate={row.original.endDate}
          dayPlus={row.original.dayPlus}
        />
      ),
    },
    {
      accessor: 'code',
      Header: '코드',
      resizable: true,
      width: 100,
    },
    {
      accessor: 'memo',
      Header: '메모',
      className: 'align-left',
      resizable: true,
      width: 200,
    },
  ];
};

export default columns;
